import * as Yup from 'yup';
import '@dfl/yup-validations';
import { ActionTakenEnum } from 'modules/sales/common/constants/action-taken.enum';

export const orderCompletedSchema = Yup.object().shape({
  actionTaken: Yup.string().oneOf(Object.keys(ActionTakenEnum)),
});
